"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TableListRow;
var _react = _interopRequireDefault(require("react"));
var _reactDnd = require("react-dnd");
var _reactDndHtml5Backend = require("react-dnd-html5-backend");
function TableListRow(_ref) {
  var className = _ref.className,
    children = _ref.children,
    id = _ref.id,
    reorderable = _ref.reorderable;
  if (reorderable) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className,
      id: id
    }, /*#__PURE__*/_react.default.createElement(_reactDnd.DndProvider, {
      backend: _reactDndHtml5Backend.HTML5Backend
    }, children));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    id: id
  }, children);
}